import { getFeeds } from "../services/apiHistory";
import { useMappedQuery } from "./queryUtils";

export function useFeeds(id, page, pageSize, filters = {}) {
  return useMappedQuery({
    queryKey: ["feeds", id, page, pageSize, filters],
    queryFn: () => getFeeds(id, page, pageSize, filters),
    dataKey: "feeds",
  });
}
